import { wireDatePicker } from "../../../shared/date_picker";

export function wireUniqueListenersPicker(rootEl, onChange) {
  return wireDatePicker({
    rootEl: rootEl || document,
    onChange,
    inputSelector: '#listener-range',
    buttonSelector: '[data-chart-type="unique_listeners"][data-chartid="uniqueListenersChartID"][data-range]',
    hiddenFromSelector: '#unique_listeners_from',
    hiddenToSelector: '#unique_listeners_to',
    maxDate: 'today',
    // Match Episode Release Performance Comparison hue (light highlight)
    activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
  });
}
